@if (this.config().menuItems; as menuItems) {
  <div
    [style.border]="'var(--list-menu-border-width) solid var(--list-menu-border-color)'"
    class="flex flex-col rounded-(--list-menu-border-radius) overflow-hidden"
  >
    @for (item of menuItems; track $index; let isLast = $last) {
      <button
        (click)="onItemClick(item)"
        [disabled]="disabled() || item.disabled"
        [class.opacity-50]="disabled() || item.disabled"
        [style.border-bottom]="!isLast ? 'var(--list-menu-border-width) solid var(--list-menu-border-color)' : 'none'"
        [style.font-family]="'var(--list-menu-font-family)'"
        class="flex items-center gap-(--list-menu-gap) px-(--list-menu-padding-x) py-(--list-menu-padding-y) text-left w-full transition-colors [background:var(--list-menu-background)] enabled:cursor-pointer enabled:hover:[background:var(--list-menu-hover-background)]"
        type="button"
      >
        @if (item.avatar) {
          <app-dynamic
            [props]="{ config: item.avatar }"
            class="shrink-0"
            componentName="Avatar"
          />
        }
        @if (item.icon) {
          <app-dynamic
            [props]="{ name: item.icon, color: 'var(--list-menu-icon-color)' }"
            class="shrink-0"
            componentName="SvgIcon"
          />
        }

        <div class="flex-1 flex flex-col gap-1 min-w-0">
          <span class="text-(--list-menu-title-color) font-semibold text-xl"> {{ item.title }} </span>
          @if (item.supportingText) {
            <span class="text-(--list-menu-support-text-color) text-sm font-bold">{{ item.supportingText }}</span>
          }
        </div>

        @if (item.showChevron) {
          <app-dynamic
            [props]="{ name: 'caret-right', color: 'var(--list-menu-chevron-color)' }"
            class="shrink-0"
            componentName="SvgIcon"
          />
        }
      </button>
    }
  </div>
}
